import { BaseQueryApi } from '@reduxjs/toolkit/query';

import getExtendedItems from '@/features/references/helpers/getExtendedItems';
import { IGrpcService } from '@/services/GrpcService';
import injectContainer from '@/services/InjectContainer';
import ServiceTypes from '@/services/ServiceTypes';

import { FiltersParameters } from '../types';

import formatFiltersParameters from './formatFiltersParameters';
import makeFiltersAggregateItem from './makeFiltersAggregateItem';
import makeFiltersRawItem from './makeFiltersRawItem';

/**
 * Запрос на получение фильтров со всем возможными значениями и
 * преобразование данных к "сырому" формату Item
 * @param api
 * @param parameters {object} Параметры запроса
 */
const fetchFilters = async (api: BaseQueryApi, parameters: FiltersParameters) => {
  const grpcService = injectContainer.get<IGrpcService>(ServiceTypes.Grpc);
  const { itemsClient } = grpcService;

  const formattedParameters = formatFiltersParameters(parameters);

  // Запрос на получение всех значений фильтров
  const { result: data = {} } = await itemsClient.aggregatePublished(formattedParameters);

  const aggregateItem = makeFiltersAggregateItem(data, parameters);

  const [extendedAggregateItem] = await getExtendedItems(api, [aggregateItem]);

  const filtersItem = makeFiltersRawItem(extendedAggregateItem, parameters);

  return filtersItem;
};

export default fetchFilters;
